/**
 * Route for `fraudscore-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudscoreIntegrationPage } from "../features/fraudscore-integration/FraudscoreIntegrationPage";

export const fraudscoreIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraudscore-integration",
	component: FraudscoreIntegrationPage,
});

export default fraudscoreIntegrationRoute;
